import TextField, { TextFieldProps } from "@mui/material/TextField";
import {
  Control,
  FieldPath,
  FieldValues,
  useController,
} from "react-hook-form";

// Binds an MUI TextField to react-hook-form. The field's validation error is
// shown once it has one (with `mode: "onTouched"`, after the first blur).
export const UFMuiTextField = <T extends FieldValues>(
  props: { name: FieldPath<T>; control: Control<T> } & Omit<
    TextFieldProps,
    "name"
  >
) => {
  const { name, control, error, helperText, ...rest } = props;
  const {
    field: { ref, ...field },
    fieldState,
  } = useController({ name, control });
  return (
    <TextField
      error={error ?? Boolean(fieldState.error)}
      helperText={helperText ?? fieldState.error?.message}
      {...field}
      {...rest}
      inputRef={ref}
      type="text"
    />
  );
};
